import { useCallback, useMemo, useState } from "react";
import ImpactList from "../../../Profile/Qualifications/ImpactList";
import { useConfirmModal } from "../../../Profile/Qualifications/hooks/useConfirmModal";
import { getDefaultShiftActions, toShiftActionItems } from "../../../Profile/Qualifications/helpers";
import { useAccess } from "../../../../utils/hooks/access";

export const hasAbsenceImpact = (impact) => !!(impact?.items?.length || impact?.shifts?.items?.length);

export const useAbsenceImpactModal = ({ onConfirm }) => {
    //TODO: move to open shift permission
    const canMove = true;
    const { hasAccess: canDelete } = useAccess("schedule.canDeleteMySchedule");
    const permissions = useMemo(() => ({ canMove, canDelete }), [canMove, canDelete]);

    const [impact, setImpact] = useState();
    const [shiftActions, setShiftActions] = useState({});

    const hasShifts = !!impact?.shifts?.items?.length;
    const blocked = hasShifts && !canMove && !canDelete;
    const missingAction = !!impact?.shifts?.items?.some((shift) => !shiftActions[shift.shiftId]);

    const renderMessage = useCallback(() => (
        <ImpactList
            impact={impact}
            shiftActions={shiftActions}
            onShiftActionsChange={setShiftActions}
            permissions={permissions}
            translationPrefix="absence-impact"
            continueLabel="absence-impact-continue"
        />
    ), [impact, shiftActions, permissions]);

    const { open: openModal, modal } = useConfirmModal({
        message: renderMessage,
        onConfirm: blocked || missingAction
            ? undefined
            : (item) => onConfirm(item, toShiftActionItems(item?.impact?.shifts?.items, shiftActions)),
    });

    const open = useCallback((item) => {
        setImpact(item.impact);
        setShiftActions(getDefaultShiftActions(item.impact?.shifts?.items, permissions));
        openModal(item);
    }, [openModal, permissions]);

    return { open, modal };
};
